import CreateSetupBackend from "../config/config.js";

let SetupBackend = null;

function showWalletAddress(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/api/v1/cripto/${data.service}/showwalletaddress?currencySymbol=${data.currencySymbol}&network=${data.network}`
  );
}

function showMarkets(service) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(`/api/v1/cripto/${service}/showmarkets`);
}

function showBalance(service) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(`/api/v1/cripto/${service}/showbalance`);
}

function createQuote(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post(
    `/api/v1/cripto/${data.service}/createquote`,
    data.body
  );
}

function createQuoteBnb(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post(`/api/v1/swapbnb/quote`, data.body);
}

function executeQuote(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post(
    `/api/v1/cripto/${data.service}/executequote`,
    data.body
  );
}

function executeTrade(data) {
  // A credencial do swap é pedida por intenção; quem a injeta é o nginx.
  SetupBackend = CreateSetupBackend({ useSwapCredentials: true });
  return SetupBackend.post(`/api/v1/swap/create`, data);
}

function executeTradeBnb(data) {
  // A credencial do swap é pedida por intenção; quem a injeta é o nginx.
  SetupBackend = CreateSetupBackend({ useSwapCredentials: true });
  return SetupBackend.post(`/api/v1/swapbnb/create`, data);
}

function showServices() {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get("/api/v1/cripto/indexservices");
}

function createWithdrawal(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.post(
    `/api/v1/cripto/${data.service}/createwithdrawal`,
    data.body
  );
}

const backendServices = {
  showWalletAddress,
  showMarkets,
  showBalance,
  createQuote,
  executeQuote,
  showServices,
  createWithdrawal,
  executeTrade,
  createQuoteBnb,
  executeTradeBnb,
};

export default backendServices;
